import { create } from 'zustand'
import rateService from '../../services/admin/rateService'

const useAdminRateStore = create((set) => ({
    rates: [],
    rate: null,
    loading: false,
    validationErrors: [],
    error: null,

    // Fetch all rates
    fetchRates: async (params) => {
        set({ loading: true, error: null })
        try {
            const response = await rateService.getRates(params)
            set({ rates: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Update an existing rate
    updateRate: async (id, rateData) => {
        set({ loading: true, error: null })
        const response = await rateService.updateRate(id, rateData)
        if (response.success) {
            set((state) => ({ rate: rateData, loading: false }))
            return { success: true, data: response.data }
        } else {
            set((state) => ({ validationErrors: response.messages, loading: false }))
            return { success: false, messages: response.messages }
        }
    },
}))

export default useAdminRateStore
